(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gf-drop-edit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gf-drop-carousel')) {
  customElements.define('gf-drop-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track=this.querySelector('ul');
      this.controls=this.closest('.gf-drop-edit').querySelector('.gf-drop-edit__arrows');
      this.controller=new AbortController();
      const signal=this.controller.signal;
      this.controls.hidden=false;
      this.controls.querySelectorAll('button').forEach(button=>button.addEventListener('click',()=>{const card=this.track.querySelector('li');if(card)this.track.scrollBy({left:Number(button.dataset.direction)*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});},{signal}));
      this.track.addEventListener('scroll',()=>this.update(),{signal,passive:true});
      this.observer=new ResizeObserver(()=>this.update());this.observer.observe(this.track);this.update();
    }
    update(){const left=this.track.scrollLeft;const max=this.track.scrollWidth-this.track.clientWidth;this.controls.querySelector('[data-direction="-1"]').disabled=left<=1;this.controls.querySelector('[data-direction="1"]').disabled=left>=max-1;}
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-drop-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gf-drop-countdown')) {
  class GFDropCountdown extends HTMLElement {
    connectedCallback() {
      this.update();
      this.interval = setInterval(() => this.update(), 30000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    nextThursday() {
      const now = new Date();
      const p = Object.fromEntries(new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Rome',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',weekday:'short',hourCycle:'h23'}).formatToParts(now).map((x) => [x.type, x.value]));
      const romeNow = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
      const offset = romeNow - now.getTime();
      const dow = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].indexOf(p.weekday);
      let target = Date.UTC(+p.year, +p.month - 1, +p.day + ((4 - dow + 7) % 7), 13, 0, 0);
      if (target <= romeNow) target += 7 * 86400000;
      return new Date(target - offset);
    }
    update() {
      const raw = this.dataset.date || '';
      const valid = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(raw);
      const target = valid ? new Date(raw) : this.nextThursday();
      if (Number.isNaN(target.getTime())) return;
      const difference = target.getTime() - Date.now();
      if (difference <= 0) { this.hidden = true; clearInterval(this.interval); return; }
      this.hidden = false;
      const minutes = Math.ceil(difference / 60000);
      this.querySelector('.gf-drop-countdown__schedule').textContent = new Intl.DateTimeFormat(this.dataset.locale || 'it', {timeZone:'Europe/Rome',day:'numeric',month:'long',hour:'2-digit',minute:'2-digit',timeZoneName:'short'}).format(target);
      this.querySelector('[data-days]').textContent=String(Math.floor(minutes/1440)).padStart(2,'0');
      this.querySelector('[data-hours]').textContent=String(Math.floor(minutes%1440/60)).padStart(2,'0');
      this.querySelector('[data-minutes]').textContent=String(minutes%60).padStart(2,'0');
      this.querySelector('[role="timer"]').hidden=false;
    }
  }
  customElements.define('gf-drop-countdown',GFDropCountdown);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
